import Dnd from '../../grid/dnd';

export default instance => {
  instance.attachEvent('onBeforeRowDragMove', (id, parent) => Dnd.onBeforeRowDragMove(id, parent));
};
